define('app/views/shipping_method_view',['app/setup'], function(takhfifan) {

  takhfifan.ShippingMethodView = Backbone.View.extend({

    events: {
      'click li' : 'updateCode'
    },

    initialize: function() {
      this.render();
      var _this = this;
      _this.isGuest = false;

      takhfifan.eventHub.on('shipping:method_updated', function(data) {
        var rates = data.shipping_methods.rates;
        var selected = data.shipping_method;

        this.collection.reset();

        _.each(rates, function(rate){
          var method = new takhfifan.ShippingMethod({
            code: rate.code,
            title: rate.title,
            price: rate.price,
            isSelected: (rate.code == selected.code && !_.isUndefined(selected.code))
          });
          _this.collection.add(method);
        });

        this.render();
        var first_method = _this.collection.first();
        this.selectCode(first_method.get('code'),first_method.get('title'));
        this.save();
      }, this);

      takhfifan.eventHub.on('checkout:guestaddress', function() {
        _this.hide();
      }, this);

      takhfifan.eventHub.on('guest_customer_info:saved', function(data) {
        _this.isGuest = true;
      },this);

      takhfifan.eventHub.on('checkout:shipping', function() {
        if(_this.isGuest) {
          _this.hide();
        }
      }, this);

      takhfifan.eventHub.on('guest_customer_address_info:saved', function(data) {
        _this.show();
      }, this);
    },

    selectCode: function(code,text) {
      this.$el.data('code', code);
      this.collection.forEach(function(method){
        var isSelected = (code == method.get('code'));
        method.set('isSelected', isSelected);
      });
      this.$el.data(code, text);
      this.render();
    },

    updateCode: function(event) {
      var $target = $(event.target);
      this.selectCode($target.data('code'),$target.text());
    },

    show: function() {
      if($('.yadisa-checkout').length){this.$el.css('display', 'block')}
      this.$el.css('visibility', 'visible');
    },

    hide: function() {
      if($('.yadisa-checkout').length){this.$el.css('display', 'none')}
      this.$el.css('visibility', 'hidden');
    },

    render: function() {
      var _this = this;
      var $methods = this.$('ul').first();
      var $method = this.$('a span.value');
      $methods.empty();
      this.collection.forEach(function(method){
        $methods.append('<li data-code="'+
          method.get('code') + '" >' +
          method.get('title')+ '</li>'
        );

        if (method.get('isSelected')) {
          $method.text(method.get('title'));
          _this.$('.tkh-shipping-price').text(method.get('price'));
        }
      });

      if (this.collection.length > 0) {
        this.$el.css('visibility', 'visible');
      } else {
        this.$el.css('visibility', 'hidden');
      }
    },

    save: function() {
      var selected = this.collection.findWhere({isSelected: true});
      if (_.isUndefined(selected) ||
        _.isNull(selected) ||
        _.isUndefined(selected.get('code')) ||
        _.isNull(selected.get('code'))
      ) {
        takhfifan.eventHub.trigger('shipping:invalid');
        return false;
      }

      var payload = {shipping_method: selected.get('code')};

      $.post(this.$el.data('action'), payload).done(function(data){
        if (!_.isNull(data)) {
          if (typeof data == 'string') {
            try {
              data = JSON.parse(data);
            } catch(err) {
              takhfifan.airbrake.notify(err);
            }
          }
          if (!_.isNull(data.error) && !_.isUndefined(data.error)) {
            takhfifan.eventHub.trigger('shipping:error', [data.message]);
            takhfifan.airbrake.notify(data);
          } else {
            takhfifan.eventHub.trigger('shipping:saved',data);
            takhfifan.eventHub.trigger('ga:checkoutOption', {option: payload["shipping_method"]});
            takhfifan.airbrake.notify(data);
          }
        }
      }).fail(function(data){
        takhfifan.eventHub.trigger(
          'shipping:error', i18n.t('connection_error')
        );
        takhfifan.airbrake.notify(data);
      });
    }
  });

});








